import { brandService } from '../_services';

const getDefaultState = () => {
  return {
    all: {},
    myRecipes: {},
    mySharedRecipes: {},
    current: {},
    loading: false,
    selectList: {},
    loading: false
  }
}

export const brands = {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    resetState ({ commit }) {
      commit('resetState')
    },
    getAllBrands({ commit }, params) {
      commit('getAllBrandsRequest');
      brandService.getAll(params)
      .then(
          brands => commit('getAllBrandsSuccess', brands),
          error => commit('getAllBrandsFailure', error)
      );
    },
    getSelectList({ commit }) {
      commit('getSelectListRequest');
      brandService.getSelectList()
      .then(
          brands => commit('getSelectListSuccess', brands),
          error => commit('getSelectListFailure', error)
      );
    },
    getById({ commit }, brandId) {
      commit('getByIdRequest');
      brandService.getById(brandId)
      .then(
          brand => commit('getByIdSuccess', brand),
          error => commit('getByIdFailure', error)
      );
    },
    addBrand({ commit }, payload){
      commit('addBrandRequest');
      brandService.addBrand(payload)
      .then(
        brands => commit('addBrandSuccess', brands),
        error => commit('addBrandFailure', error)
      )
    },
    updateBrand({ commit }, payload){
      commit('updateBrandRequest');
      brandService.updateBrand(payload)
      .then(
        brands => commit('updateBrandSuccess', brands),
        error => commit('updateBrandFailure', error)
      )
    },
    deleteBrand({ commit }, payload){
      commit('deleteBrandRequest');
      brandService.deleteBrand(payload)
      .then(
        commit('deleteBrandSuccess'),
        error => commit('deleteBrandFailure', error)
      )
      return true;
    },
    getCurrentBrand({ commit }) {
      commit('getCurrentBrandRequest');

      const user = JSON.parse(localStorage.getItem('authentication'))
      let subdomain =  window.location.host.split('.')[1] ? window.location.host.split('.')[0] : "dcd33d07-6d77-4fb9-86d9-0b9cb5a88159";
      
      if (user) {
        subdomain = user.user.companyId
      }

      brandService.getCurrentBrand(subdomain)

      .then(
          company => commit('getCurrentBrandSuccess', company),
          error => commit('getCurrentBrandFailure', error)
      );
    }
  },
  mutations: {
    resetState (state) {
      Object.assign(state, getDefaultState())
    },
    getAllBrandsRequest(state) {
        state.loading = true;
    },
    getAllBrandsSuccess(state, brands) {
        state.all = Object.values(brands);
        state.loading = false;
    },
    getAllBrandsFailure(state, error) {
        state.all = { error };
        state.loading = false;
    },
    getSelectListRequest(state) {
        state.selectList = { loading: true };
    },
    getSelectListSuccess(state, brands) {
        state.selectList = Object.values(brands);
    },
    getSelectListFailure(state, error) {
        state.selectList = { error };
    },
    getByIdRequest(state) {
      state.current = { loading: true };
    },
    getByIdSuccess(state, brand) {
      state.current = brand;
    },
    getByIdFailure(state, error) {
        state.current = { error };
    },
    addBrandRequest(state, brand) {
        state.current = brand
    },
    addBrandSuccess(state, brand) {
        state.current = brand;
    },
    updateBrandRequest(state, brand) {
      state.current = brand
    },
    updateBrandSuccess(state, brand) {
      if(brand.id == state.current.brand.id){
        state.current = brand;
      }
    },
    addBrandFailure(state, error) {
      state.update = { error };
    },
    deleteBrandRequest(state, brand) {
      state.current = brand
    },
    deleteBrandSuccess(state) {
        state.current = {};
        return true;
    },
    deleteBrandFailure(state, error) {
      state.update = { error };
    },
    getCurrentBrandRequest(state) {
      state.current = { loading: true };
    },
    getCurrentBrandSuccess(state, company) {
      state.current = { company: company };
    },
    getCurrentBrandFailure(state, error) {
      state.current = { error };
    },
  }
}